export type LocaleAlternate = {
  hreflang: string;
  href: string;
};

type GetLocaleHrefParams = {
  code: string;
  pathname: string;
  search: string;
  hash: string;
  alternates?: Array<LocaleAlternate>;
};

function withLocaleForRootHref(href: string, code: string): string {
  try {
    const url = new URL(href);
    if (url.pathname === "/") {
      url.pathname = `/${code}/`;
      return url.href;
    }
  } catch {
    return href;
  }

  return href;
}

export function getLocaleHref({
  code,
  pathname,
  search,
  hash,
  alternates = [],
}: GetLocaleHrefParams): string {
  const alternate = alternates.find((item) => item.hreflang === code);
  if (alternate?.href) {
    return withLocaleForRootHref(alternate.href, code);
  }

  const [, , ...pathParts] = pathname.split("/");
  const nextPathname = ["", code, ...pathParts].join("/");
  return `${nextPathname}${search}${hash}`;
}
